__turbopack_context__.v({
  "root": "Container-module__9Qsbzq__root",
});
